module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"arranged":"Arranged","failed":"Failed","matching":"Matching"},"id":{"arranged":"Sudah diatur","failed":"gagal","matching":"mencari rider"}}')
  delete Component.options._Ctor
}
